const { conditionsType, columnDataType } = require("./types");

export const parseConditionHelper = ({
  type,
  currentValue = "",
  dataArray,
  columnType = columnDataType.text,
}) => {
  const isTypesForEmpty = [
    conditionsType.uniqueValue,
    conditionsType.empty,
    conditionsType.not_empty,
  ];

  const fixedCurrentNumber = Number(currentValue).toFixed(2);

  const valuesByType = {
    currentValue: {
      [columnDataType.text]: String(currentValue).toLowerCase().trim(),
      [columnDataType.number]: isTypesForEmpty ? currentValue : Number(fixedCurrentNumber),
      [columnDataType.checkbox]: currentValue,
      [columnDataType.date]: !!currentValue ? new Date(currentValue) : null,
    },
    firstValue: {
      [columnDataType.text]: String(dataArray[0])?.toLowerCase().trim(),
      [columnDataType.number]: Number(dataArray[0]),
      [columnDataType.checkbox]: dataArray[0],
      [columnDataType.date]: !!dataArray[0] ? new Date(dataArray[0]) : null,
    },
    secondInputValue: {
      [columnDataType.text]: String(dataArray[1])?.toLowerCase().trim(),
      [columnDataType.number]: Number(dataArray[1]),
      [columnDataType.checkbox]: dataArray[1],
      [columnDataType.date]: !!dataArray[1] ? new Date(dataArray[1]) : null,
    },
  };

  const currentConditionValue = valuesByType.currentValue[columnType]

  const firstValue = valuesByType.firstValue[columnType]

  const secondInputValue = valuesByType.secondInputValue[columnType]

  const conditionFunctions = {
    [conditionsType.uniqueValue]: () => true,
    [conditionsType.empty]: () => !currentConditionValue,
    [conditionsType.predictValue]: () => {
      const isCurrentValueDate = currentValue instanceof Date;
      const parseDateString = (dateString) => {
        return new Date(dateString);
      };

      if (isCurrentValueDate) {
        return dataArray.some(dateString => {
          const date = parseDateString(dateString);

          return (
            currentValue.getFullYear() === date.getFullYear() &&
            currentValue.getMonth() === date.getMonth() &&
            currentValue.getDate() === date.getDate()
          );
        });
      } else {
        return dataArray.includes(currentValue);
      }
    },
    [conditionsType.notEmpty]: () => !!currentConditionValue,
    [conditionsType.moreThan]: () => !!currentConditionValue ? (currentConditionValue > firstValue) : false,
    [conditionsType.moreThanOrEqualTo]: () => !!currentConditionValue ? (currentConditionValue >= firstValue) : false,
    [conditionsType.lessThan]: () => !!currentConditionValue ? (currentConditionValue < firstValue) : false,
    [conditionsType.lessThanOrEqualTo]: () => !!currentConditionValue ? (currentConditionValue <= firstValue) : false,
    [conditionsType.equal]: () => !!currentConditionValue ? (currentConditionValue === firstValue) : false,
    [conditionsType.notEqual]: () => !!currentConditionValue ? (currentConditionValue !== firstValue) : false,
    [conditionsType.isBetween]: () => !!currentConditionValue ? (currentConditionValue >= firstValue && currentConditionValue <= secondInputValue) : false,
    [conditionsType.isNotBetween]: () => !!currentConditionValue ? (currentConditionValue < firstValue || currentConditionValue > secondInputValue) : false,
    [conditionsType.dateIs]: () => !!currentConditionValue ? (currentConditionValue?.toDateString() === firstValue?.toDateString()) : false,
    [conditionsType.dateIsBefore]: () => !!currentConditionValue ? (firstValue > currentConditionValue) : false,
    [conditionsType.dateIsAfter]: () => !!currentConditionValue ? (firstValue < currentConditionValue) : false,
    [conditionsType.textContains]: () => !!currentConditionValue ? (currentConditionValue.includes(firstValue)) : false,
    [conditionsType.textDoesNotContain]: () => !!currentConditionValue ? (!currentConditionValue.includes(firstValue)) : false,
    [conditionsType.textStartsWith]: () => !!currentConditionValue ? (currentConditionValue.startsWith(firstValue)) : false,
    [conditionsType.textEndsWith]: () => !!currentConditionValue ? (currentConditionValue.endsWith(firstValue)) : false,
    [conditionsType.textIsExactly]: () => !!currentConditionValue ? (currentConditionValue === firstValue) : false,
  }
  return conditionFunctions?.[type]?.()
};
